export default __webpack_public_path__ + "static/gallery-art-mixed-01a531103aadb51640753f07b711e675.jpg";